import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import Layout from "../views/Layout.vue";
// import store from '@/store'
Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const routes = [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("../views/Home.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/control",
        name: "control",
        component: () => import("../views/control.vue"),
        meta: {
          title: "用电场景",
          keepAlive: true,
        },
      }, 
      {
        path: "/controlAir",
        name: "controlAir",
        component: () => import("../views/controlAir"),
        meta: {
          title: "空调控制",
          keepAlive: true,
        },
      },
      {
        path: "/my",
        name: "my",
        component: () => import("../views/my.vue"),
      },
      {
        path: "",
        redirect: "/home",
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login.vue"),
  },
  {
    path: "/ChangePassword",
    name: "ChangePassword",
    component: () => import("../views/ChangePassword.vue"),
  },
  {
    path: "/Announcement",
    name: "Announcement",
    component: () => import("../views/Announcement.vue"),
  },
  {
    path: "/page",
    name: "page",
    component: () => import("../views/page.vue"),
  },
  {
    path: "/eleInfo",
    name: "eleInfo",
    component: () => import("../views/eleInfo.vue"),
  },
  {
    path: "/analyse",
    name: "analyse",
    component: () => import("../pages/analyse.vue"),
    meta: {
      title: "用电分析",
      keepAlive: true,
    },
  },
  {
    path: "/energy",
    name: "energy",
    component: () => import("../pages/energy.vue"),
    meta: {
      title: "区域能耗分析",
    },
  },
  {
    path: "/equipment",
    name: "equipment",
    component: () => import("../pages/equipment.vue"),
    meta: {
      title: "设备用能分析",
    },
  },
  {
    path: "/scenario",
    name: "scenario",
    component: () => import("../pages/scenario.vue"),
    meta: {
      title: "用电场景",
      keepAlive: true,
    },
  },
  {
    path: "/scendetail",
    name: "scendetail",
    component: () => import("../pages/scendetail.vue"),
    meta: {
      title: "用电详情",
    },
  },
  {
    path: "/usesafely",
    name: "usesafely",
    component: () => import("../pages/usesafely.vue"),
    meta: {
      title: "安全用电",
      keepAlive: true,
    },
  },
  {
    path: "/Inputpower",
    name: "Inputpower",
    component: () => import("../pages/Inputpower.vue"),
    meta: {
      title: "负载总功率",
    },
  },
  {
    path: "/temp",
    name: "temp",
    component: () => import("../pages/temp.vue"),
    meta: {
      title: "温度监控",
    },
  },
  {
    path: "/leakage",
    name: "leakage",
    component: () => import("../pages/leakage.vue"),
    meta: {
      title: "漏电电流",
    },
  },
  {
    path: "/airDetail",
    name: "airDetail",
    component: () => import("../pages/airDetail.vue"),
    meta: {
      title: "空调详情",
    },
  },
  {
    path: "/warningDetail",
    name: "warningDetail",
    component: () => import("../pages/warningDetail.vue"),
    meta: {
      title: "预警详情",
    },
  },
  {
    path: "/safelyDetail",
    name: "safelyDetail",
    component: () => import("../pages/safelyDetail.vue"),
    meta: {
      title: "事件概况",
      keepAlive: true,
    },
  },

  {
    path: "*",
    redirect: "/index",
  },

  // Equipment
];

// 两种模式  hash模式（默认，带#）和history模式
const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      console.log(savedPosition);
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});
// 登录拦截
// 条件一： /user /user/profile /user/chat 需要登录
// 条件二： 没有token信息
router.beforeEach((to, from, next) => {
  // 跳转的时候需要 带上当前的路由地址
  // to.path.startsWith('/user')
  const login = {
    path: "/home",
    // query: { redirect: to.path }
  };
  if (to.path !== "/home" && !store.state.user.access_token)
    return next(login);
  // if (!store.state.user) return next(login)
  next();
});

export default router;
